var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H5 from 'syf-component-library/ui/typography/H5';
import { Stack } from 'syf-component-library/ui/spacing';
import { translate } from '../../../../strings/i18n';
import { NoManageCardHoldersAddedContainer } from './subcomponents';
var NoManageCardHoldersAdded = function () {
    return (_jsxs(NoManageCardHoldersAddedContainer, __assign({ top: "large", hideOnBreakpointDown: "medium", "data-testid": "authorized-users__no-data", "data-cy": "message-box-container" }, { children: [_jsx(Stack, { size: "small", hideOnBreakpointUp: "medium", "data-testid": "authorized-users__no-data", "data-cy": "message-box-container" }), _jsx(H5, __assign({ weight: "bold" }, { children: translate('noAccountAddedMessage') }))] })));
};
export default NoManageCardHoldersAdded;
